import Vue from 'vue'
import en from '../lang/languages/en'
import cn from '../lang/languages/cn'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
export const options = {
    theme: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    },
    customProperties: true,
    iconfont: 'mdi',
    lang: {
        locales: {
            en,
            cn
        },
        current: 'en'
    }
};

Vue.use(Vuetify);
